export { Filter } from './badwords.js';
